import React from 'react';

interface ArrowMarkProps {
  /** 'up-right' is the outbound-link mark; 'right' is the forward mark */
  dir?: 'up-right' | 'right';
  className?: string;
}

/**
 * A drawn arrow, because the typed ones were not the same shape twice.
 *
 * The self-hosted Space Grotesk subset carries U+2191 and U+2193 but neither
 * U+2192 nor U+2197, so those two fell out of the @font-face unicode-range and
 * were rendered by whatever the platform's `sans-serif` happens to be:
 * Helvetica on a Mac, something heavier on iOS, where U+2197 can also resolve
 * to an emoji face. Identical markup, a different glyph on every device.
 *
 * Sized in `em` so it tracks whatever type it sits next to, and stroked in
 * `currentColor` so it inherits hover states for free.
 */
const ArrowMark: React.FC<ArrowMarkProps> = ({ dir = 'up-right', className = '' }) => (
  <svg
    viewBox="0 0 12 12"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    // the glyph is drawn pointing up-right; a quarter turn of that is 'right'
    style={dir === 'right' ? { transform: 'rotate(45deg)' } : undefined}
    className={`shrink-0 ${className}`}
  >
    <path d="M3.4 8.6 8.6 3.4" />
    <path d="M4.6 3.4h4v4" />
  </svg>
);

export default ArrowMark;
